module.exports = __webpack_public_path__ + "static/media/box.3be925d2.png";